<template>
  <div class="pr-card">
    <div class="pr-card-title">
      <pull-request-outlined class="pr-card-icon" />
      PR 协作效能
    </div>
    <div class="pr-stat-row">
      <div class="pr-stat-item pr-stat-blue">
        <bar-chart-outlined class="pr-stat-icon" style="color: #2B7FFF;" />
        <div class="pr-stat-label">总 PR 数</div>
        <div class="pr-stat-value">{{ formatNumber(prData.created?.count) }}</div>
      </div>
      <div class="pr-stat-item pr-stat-green">
        <check-circle-outlined class="pr-stat-icon" style="color: #00C950;" />
        <div class="pr-stat-label">已合并</div>
        <div class="pr-stat-value">{{ formatNumber(prData.merged?.count) }}</div>
      </div>
      <div class="pr-stat-item pr-stat-orange">
        <clock-circle-outlined class="pr-stat-icon" style="color: #FF6900;" />
        <div class="pr-stat-label">进行中</div>
        <div class="pr-stat-value">{{ formatNumber(prData.open?.count) }}</div>
      </div>
      <div class="pr-stat-item pr-stat-red">
        <stop-outlined class="pr-stat-icon" style="color: #FB2C36;" />
        <div class="pr-stat-label">已关闭</div>
        <div class="pr-stat-value">{{ formatNumber(prData.closed?.count) }}</div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import axios from 'axios';
import { PullRequestOutlined, BarChartOutlined, CheckCircleOutlined, ClockCircleOutlined, StopOutlined } from '@ant-design/icons-vue';

const prData = ref({
  created: { count: null },
  merged: { count: null },
  open: { count: null },
  closed: { count: null }
});

const formatNumber = (n) => {
  if (n === null || n === undefined) return '-';
  const num = typeof n === 'number' ? n : Number(n);
  return Number.isNaN(num) ? n : num.toLocaleString();
};

const fetchData = async () => {
  try {
    const res = await axios.get('/metric/prDesignBoard', { params: { time: 1 } });
    if (res.data?.code === 200) {
      prData.value = res.data.data;
    }
  } catch (error) {
    console.error('PR协作效能数据加载失败:', error);
  }
};

onMounted(() => {
  fetchData();
});
</script>

<style scoped>
.pr-card {
  background: #fff;
  border: 1px solid #E5E7EB;
  border-radius: 12px;
  padding: 24px;
}

.pr-card-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 16px;
  font-weight: 600;
  color: #1a1a2e;
  margin-bottom: 20px;
}

.pr-card-icon {
  font-size: 18px;
  color: #50A2FF;
}

.pr-stat-row {
  display: flex;
  gap: 16px;
}

.pr-stat-item {
  flex: 1;
  padding: 16px;
  border-radius: 8px;
  position: relative;
}

.pr-stat-blue {
  background: #e6f4ff;
  border: 1px solid #91caff;
}

.pr-stat-green {
  background: #f6ffed;
  border: 1px solid #b7eb8f;
}

.pr-stat-orange {
  background: #fff7e6;
  border: 1px solid #ffd591;
}

.pr-stat-red {
  background: #fff1f0;
  border: 1px solid #ffa39e;
}

.pr-stat-label {
  font-size: 13px;
  color: #666;
  margin-bottom: 8px;
}

.pr-stat-value {
  font-size: 28px;
  font-weight: 700;
  color: #1a1a2e;
  line-height: 1;
}

.pr-stat-icon {
  position: absolute;
  top: 12px;
  left: 12px;
  font-size: 20px;
}
</style>
